import { GzAntimalwareOnDemandWebComponent } from './component/GzAntimalwareOnDemandWebComponent';

export { GzAntimalwareOnDemandWebComponent };
